import CourseService from '../../../services/courses.service';
import ClassService from '../../../services/classes.service';
import PassService from '../../../services/passes.service';

export async function getCourse(store, id) {
    const state = store.state;
    const course = await CourseService().getCourse(id);
    const countries = await CourseService().getCountriesList();
    store.setState({ CourseDetails: { ...state.CourseDetails, course, countries } });
}

export async function saveCourse(store, course) {
    await CourseService().saveCourse(course);
    store.setState({ CourseDetails: { ...store.state.CourseDetails, course } })
}

export async function getClasses(store, id) {
    const state = store.state;
    const classes = await CourseService().getClasses(id);
    const classGroups = await ClassService().getClassGroups();
    const tradeTypes = await ClassService().getTradeTypes();
    store.setState({ CourseDetails: { ...state.CourseDetails, classes, classGroups, tradeTypes } });
}

export async function enableClass(store, { courseId, classId }) {
    await ClassService().enableClass(courseId, classId);

    let classes = [...store.state.CourseDetails.classes];
    let index = classes.findIndex(c => c.id === classId)
    if (index === -1)
        return;

    classes.splice(index, 1, { ...classes[index], enabled: true });
    store.setState({ CourseDetails: { ...store.state.CourseDetails, classes } });
}

export async function disableClass(store, { courseId, classId }) {
    await ClassService().disableClass(courseId, classId);

    let classes = [...store.state.CourseDetails.classes];
    let index = classes.findIndex(c => c.id === classId)
    if (index === -1)
        return;

    classes.splice(index, 1, { ...classes[index], enabled: false });
    store.setState({ CourseDetails: { ...store.state.CourseDetails, classes } });
}
export async function editClass(store, { classId, displayLabel, classGroupId, tradeType, passData, passInfo }) {
    await ClassService().editClass(classId, displayLabel, classGroupId, tradeType, passData, passInfo);
    let id = store.state.CourseDetails.course.id;
    await this.getClasses(store, id);
    let classes = [...store.state.CourseDetails.classes];
    let index = classes.findIndex(c => c.id === classId)
    if (index === -1)
        return;

    classes.splice(index, 1, { ...classes[index], classGroupId, tradeType });
    store.setState({ CourseDetails: { ...store.state.CourseDetails, classes } });
}

export async function getConfig(store, id) {
    const state = store.state;
    let config = await CourseService().getConfig(id);
    //set Default Value 8.25
    config.course.tradeSalesTaxPercentage = config?.course?.tradeSalesTaxPercentage != null ? config.course.tradeSalesTaxPercentage : 8.25
    store.setState({ CourseDetails: { ...state.CourseDetails, configuration: config } });
}

export async function editConfig(store, config) {
    await CourseService().editConfig(config.id, config.values);
    store.setState({ CourseDetails: { ...store.state.CourseDetails, configuration: config.values } })
}

export async function getPass(store, courseId) {
    const passId = await PassService().getPass(courseId);
    store.setState({ CourseDetails: { ...store.state.CourseDetails, passId } })
}

export async function savePass(store, { courseId, passId }) {
    await PassService().savePass(courseId, passId);
}

export async function getPendingAllocationRounds(store, { courseId, ruleId }) {
    const state = store.state;
    const tradeBanking = await CourseService().getPendingAllocationRounds(courseId, ruleId);
    store.setState({ CourseDetails: { ...state.CourseDetails, tradeBanking } });
    return tradeBanking;
}
export async function editPendingAllocationRounds(store, pendingAllocationRoundsDetails) {
    const state = store.state;
    await CourseService().editPendingAllocationRounds(pendingAllocationRoundsDetails);
    getPendingAllocationRounds(store, { courseId: pendingAllocationRoundsDetails.courseId, ruleId: pendingAllocationRoundsDetails.ruleId }).then(x => {
        getConfig(store, pendingAllocationRoundsDetails.courseId);
    })
}

export async function getTeeTimeDetails(store, { courseId, teetimeDate, rateTypeId }) {
    try {
        const state = store.state;
        const result = await CourseService().getTeeTimeDetails(courseId, teetimeDate, rateTypeId);
        if (result) {
            const teetimeRequestURL = result.Item1;
            const teetimeResponseDetails = result.Item2;
            store.setState({ CourseDetails: { ...state.CourseDetails, teetimeResponseDetails, teetimeRequestURL } });
        }
        return result;
    }
    catch (error) {
        alert("API error");
    }
}

export async function getCountriesList(store) {
    const state = store.state;
    const countries = await CourseService().getCountriesList();
    store.setState({ CourseDetails: { ...state.CourseDetails, countries } });
    return countries;
}